<script lang="ts">
  import { addRoute } from '@integro/core';
  import { gettext, pgettext, ngettext, npgettext } from '@integro/gettext';
  addRoute({
    name: 'settings.general',
    path: 'general',
    component: 'GeneralSettings',
  });
</script>

<script setup lang="ts">
  import {
    computed,
    nextTick,
    onActivated,
    onBeforeUnmount,
    onMounted,
    reactive,
    ref,
    watch,
  } from 'vue';
  import {
    actions as actionTypes,
    useUserComponent,
    userComponentProps,
    useHelpers,
    createComponentScope,
    Resource,
    uniqueID,
  } from '@integro/core';
  import type { IAppHelpers } from '@integro/core';
  import * as _ from 'lodash';

  defineOptions({
    name: 'GeneralSettings',
  });

  const componentMetadata = {
    kind: 'page',
  };

  const emit = defineEmits(['reload', 'close', 'save']);

  const props = defineProps({
    ...userComponentProps,
  });

  const {
    $app,
    $fn,
    $i18n,
    $store,
    $config,
    $imodal,
    $notification,
    $tabs,
    $route,
    $router,
    gettext,
    pgettext,
    ngettext,
    npgettext,
    schemaDefaults,
    getSchema,
    searchDataSource,
    randomElementId,
    datetime,
    date,
    time,
    number,
    money,
    distance,
    username,
    filesize,
  } = useHelpers();

  const sendmailResult = ref(null);
  const ux = ref([]);
  const b_7315092382398562_noShow = computed(() => false);
  const b_7315092382398562_modalBindings = computed(() => ({
    size: 'sm',
  }));

  const $data = computed(() => ({
    sendmailResult: sendmailResult.value,
    ux: ux.value,
    b_7315092382398562_noShow: b_7315092382398562_noShow.value,
    b_7315092382398562_modalBindings: b_7315092382398562_modalBindings.value,
  }));

  const {
    loading,
    error,
    loaded,
    reloading,
    showLoadingIndicator,
    loadDataThrottled,
    friendlyName,
    loadData,
    touchLastLoaded,
    handleError,
    setData,
    forms,
    registerForm,
    unregisterForm,
    canLoadData,
    isModalComponent,
    modalName,
    pageDocument: _pageDocument,
    routeTab,
    ux: _ux,
    componentMetadata: _componentMetadata,
    $uid,
    lastLoaded,
  } = useUserComponent(props, {
    metadata: componentMetadata,
    dataSpecs: [
      { name: 'sendmailResult' },
      { name: 'ux' },
      { name: 'b_7315092382398562_noShow', nodeId: '7315092382398562' },
      { name: 'b_7315092382398562_modalBindings', nodeId: '7315092382398562' },
    ],
    loaders: {},
    ux: {},
    dataRefs: {
      sendmailResult,
      ux,
      b_7315092382398562_noShow,
      b_7315092382398562_modalBindings,
    },
  });

  const $component = createComponentScope(
    {
      $app,
      $fn,
      $i18n,
      $store,
      $imodal,
      $notification,
      $tabs,
      $router,
    } as IAppHelpers,
    {
      emit,
      forms,
      error,
      isModalComponent,
      modalName,
      componentMetadata,
      loadData,
      registerForm,
      unregisterForm,
      setData,
      touchLastLoaded,
      handleError,
    }
  );

  const pageDocument = computed(() => {
    return null;
  });
  const documentTitle = computed(() => {
    return pageDocument.value
      ? Array.isArray(pageDocument.value.title)
        ? pageDocument.value.title.filter(Boolean).join(' ')
        : pageDocument.value.title
      : null;
  });

  watch(
    pageDocument,
    (newDoc) => {
      if (newDoc) {
        _pageDocument.value = newDoc;
      }
    },
    { immediate: true }
  );

  const act_7315092382398562_closeModal_znhpvqhih_getActionArgs = async (
    $event
  ) => {
    return {
      name: props.modalName,
      result: {
        close: true,
        cancel: true,
      },
    };
  };
  const act_1269646916756998_setData_299jih170_getActionArgs = async (
    $event
  ) => {
    return {
      path: 'sendmailResult',
      value: null,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    };
  };
  const act_1269646916756998_setData_1wbe9z3ay_getActionArgs = async (
    $event
  ) => {
    return {
      path: 'sendmailResult',
      value: true,
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    };
  };
  const act_1269646916756998_request_yfd3rdim9_getActionArgs = async (
    $event
  ) => {
    return {
      operation: 'post_sendmail_test',
      data: {},
    };
  };

  const act_7315092382398562_closeModal_znhpvqhih =
    new actionTypes.CloseModalAction({
      actionArgs: act_7315092382398562_closeModal_znhpvqhih_getActionArgs,
    });
  const inst_evh_7315092382398562_close_wuhcih12j =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_closeModal_znhpvqhih,
      event: 'close',
      displayName: 'closeModal',
    });
  const inst_evh_7315092382398562_close = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_close_wuhcih12j],
    event: 'close',
  });
  const act_7315092382398562_reloadComponentData_gpp9o28gm =
    new actionTypes.ReloadComponentDataAction({});
  const inst_evh_7315092382398562_reload_8id8np0k3 =
    new actionTypes.EventHandlerImpl({
      action: act_7315092382398562_reloadComponentData_gpp9o28gm,
      event: 'reload',
      displayName: 'reloadComponentData',
    });
  const inst_evh_7315092382398562_reload = new actionTypes.EventHandlerGroup({
    handlers: [inst_evh_7315092382398562_reload_8id8np0k3],
    event: 'reload',
  });
  const act_1269646916756998_setData_299jih170 = new actionTypes.SetDataAction({
    actionArgs: act_1269646916756998_setData_299jih170_getActionArgs,
  });
  const inst_evh_1269646916756998_clickPreventStop_rvcz5emxq =
    new actionTypes.EventHandlerImpl({
      action: act_1269646916756998_setData_299jih170,
      event: 'click.prevent.stop',
      displayName: 'setData',
    });
  const act_1269646916756998_setData_1wbe9z3ay = new actionTypes.SetDataAction({
    actionArgs: act_1269646916756998_setData_1wbe9z3ay_getActionArgs,
  });
  const inst_evh_1269646916756998_success_x7n0r8639 =
    new actionTypes.EventHandlerImpl({
      action: act_1269646916756998_setData_1wbe9z3ay,
      event: 'success',
      displayName: 'setData',
    });
  const act_1269646916756998_request_yfd3rdim9 = new actionTypes.RequestAction({
    actionArgs: act_1269646916756998_request_yfd3rdim9_getActionArgs,
    displayName: 'sendmail',
    events: [inst_evh_1269646916756998_success_x7n0r8639],
  });
  const inst_evh_1269646916756998_clickPreventStop_ddow0bqne =
    new actionTypes.EventHandlerImpl({
      action: act_1269646916756998_request_yfd3rdim9,
      event: 'click.prevent.stop',
      displayName: 'sendmail',
    });
  const inst_evh_1269646916756998_clickPreventStop =
    new actionTypes.EventHandlerGroup({
      handlers: [
        inst_evh_1269646916756998_clickPreventStop_rvcz5emxq,
        inst_evh_1269646916756998_clickPreventStop_ddow0bqne,
      ],
      event: 'click.prevent.stop',
    });

  const actions = {
    inst_evh_7315092382398562_close_wuhcih12j,
    inst_evh_7315092382398562_close,
    inst_evh_7315092382398562_reload_8id8np0k3,
    inst_evh_7315092382398562_reload,
    inst_evh_1269646916756998_clickPreventStop_rvcz5emxq,
    inst_evh_1269646916756998_success_x7n0r8639,
    inst_evh_1269646916756998_clickPreventStop_ddow0bqne,
    sendmail: inst_evh_1269646916756998_clickPreventStop_ddow0bqne,
    inst_evh_1269646916756998_clickPreventStop,
  };

  const evh_7315092382398562_close_wuhcih12j = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close_wuhcih12j.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_close = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_close.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload_8id8np0k3 = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload_8id8np0k3.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_7315092382398562_reload = async (event, scope) => {
    return await actions.inst_evh_7315092382398562_reload.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1269646916756998_clickPreventStop_rvcz5emxq = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_1269646916756998_clickPreventStop_rvcz5emxq.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1269646916756998_success_x7n0r8639 = async (event, scope) => {
    return await actions.inst_evh_1269646916756998_success_x7n0r8639.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1269646916756998_clickPreventStop_ddow0bqne = async (
    event,
    scope
  ) => {
    return await actions.inst_evh_1269646916756998_clickPreventStop_ddow0bqne.executeFromDOM(
      $component,
      event,
      scope
    );
  };
  const evh_1269646916756998_clickPreventStop = async (event, scope) => {
    return await actions.inst_evh_1269646916756998_clickPreventStop.executeFromDOM(
      $component,
      event,
      scope
    );
  };

  defineExpose({
    documentTitle,
    pageDocument: _pageDocument,
    routeTab,
    loadData,
    loading,
    loaded,
    error,
  });
</script>

<template>
  <ItpPage
    :header="documentTitle"
    :loaded="loaded"
    :noShow="b_7315092382398562_noShow"
    :loading="showLoadingIndicator"
    :reloading="reloading"
    :error="error"
    :modal="modal"
    :modalBindings="b_7315092382398562_modalBindings"
    itp-cname="GeneralSettings"
    @close="evh_7315092382398562_close($event, {})"
    @reload="evh_7315092382398562_reload($event, {})"
  >
    <div class="h-100 overflow-auto px-3" v-if="loaded">
      <div class="card my-3">
        <div class="card-body">
          <h5>
            {{ pgettext('Settings', 'Email settings') }}
          </h5>
          <p class="card-text">
            {{
              gettext("Send a test email to the current user's email address.")
            }}
          </p>
          <ItpBox direction="column" alignItems="start">
            <ItpButton
              :text="pgettext('Tasks|Command', 'Send test email')"
              icon="mdi:cog"
              :spinning="actions.sendmail.isRunning"
              @click.prevent.stop="
                evh_1269646916756998_clickPreventStop($event, {})
              "
            >
            </ItpButton>
            <ItpAlert
              type="success"
              :show="sendmailResult === true"
              dismissible
              class="mt-3"
            >
              <span>
                {{ pgettext('Settings', 'Email has been successfully sent.') }}
              </span>
            </ItpAlert>
          </ItpBox>
        </div>
      </div>
    </div>
  </ItpPage>
</template>
